import React, { useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function ListLinkEditor({ event, onSaved }) {
  const [url, setUrl] = useState(event.list_url || "");
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    try {
      await api.patch(`/events/${event.id}/list-link`, { list_url: url });
      toast.success(url ? "Link lista salvato" : "Link lista rimosso");
      onSaved();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore");
    } finally { setSaving(false); }
  };
  return (
    <div className="flex items-center gap-2 mt-2 w-full">
      <span className="label-mono text-[9px] text-neon whitespace-nowrap">LINK LISTA</span>
      <input value={url} onChange={e=>setUrl(e.target.value)} placeholder="https://..."
        className="input-dark !py-1 text-xs font-mono flex-1" data-testid={`list-link-input-${event.id}`}/>
      <button onClick={save} disabled={saving} className="btn-primary !py-1 !px-3 text-[10px]" data-testid={`list-link-save-${event.id}`}>
        {saving ? "..." : "SALVA"}
      </button>
    </div>
  );
}
